import '../styles/components/select.css';

const Select = ({
  options = [],
  leftIcon,
  children,
  onChange,
  value,
  width,
  height,
  ...props
}) => {
  const defaultText = children || '선택하세요';
  const defaultValue = value || 'default';

  const wrapperStyle = {
    ...(width && { width }),
    ...(height && { height }),
  };

    const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value); 
    }
  };
  
  return (
    <div className="select-wrapper custom-mantine-select" style={wrapperStyle}>
        {leftIcon && <div className="select-icon">{leftIcon}</div>}
        <select
            className={`select ${leftIcon ? 'select-with-icon' : ''}`}
            onChange={handleChange}
            value={defaultValue}
            {...props}
        >
            <option value="default">{defaultText}</option>
            {options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    </div>
  );
};

export default Select;
